import { useEffect, useState } from "react";
import { Plus, Minus } from "lucide-react";
import { fetchFaq } from "@/lib/api";
import useFAQSchema from "@/hooks/useFAQSchema";

export default function FAQ() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    fetchFaq().then(setItems).catch(() => setItems([]));
  }, []);

  useFAQSchema(items);

  if (!items.length) return null;

  return (
    <section id="faq" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="text-center mb-14 sm:mb-20">
          <div className="mono text-[11px] uppercase tracking-[0.3em] text-coral mb-5 reveal">
            / Ofte stilte spørsmål
          </div>
          <h2 className="reveal text-4xl sm:text-6xl font-bold text-white leading-[1]" data-testid="faq-headline">
            Lurer du på <span className="text-gradient">noe?</span>
          </h2>
        </div>

        <div className="space-y-3">
          {items.map((f, i) => {
            const isOpen = open === f.id;
            return (
              <div
                key={f.id}
                className="reveal"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div
                  className={`rounded-2xl border transition-colors duration-300 overflow-hidden ${
                    isOpen ? "border-cyan/40 bg-[hsl(var(--hs-bg-3))]" : "hairline bg-[hsl(var(--hs-bg-2))]"
                  }`}
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    className="w-full flex items-center justify-between gap-6 px-6 py-5 text-left"
                    onClick={() => setOpen(isOpen ? null : f.id)}
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="text-white font-semibold text-lg pr-2">{f.question}</span>
                    <span
                      className={`w-9 h-9 rounded-full shrink-0 grid place-items-center transition-all ${
                        isOpen ? "bg-cyan text-[#02121a]" : "bg-white/5 text-white/70"
                      }`}
                    >
                      {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </span>
                  </button>
                  <div
                    className="grid transition-[grid-template-rows] duration-300 ease-out"
                    style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                  >
                    <div className="overflow-hidden">
                      <p className="px-6 pb-6 text-white/70 leading-relaxed">{f.answer}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
